import '@babel/polyfill'
import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import firebase from 'firebase';
//require('firebase/auth');
//require('firebase/firestore');
// import "firebase/auth";
// import "firebase/firestore";
console.log('Initializing Firebase');
let app;
// Initialize Firebase
var config = {
  apiKey: "AIzaSyAGbjuXo49V1kaA1lXRGB4Y5-5g-19vkvw",
  authDomain: "southview-buzz-book.firebaseapp.com",
  databaseURL: "https://southview-buzz-book.firebaseio.com",
  projectId: "southview-buzz-book",
  storageBucket: "southview-buzz-book.appspot.com",
  messagingSenderId: "185134591994"
};
firebase.initializeApp(config);
console.log('Firebase initialized.', firebase);

Vue.config.productionTip = false;
firebase.auth().onAuthStateChanged(function(user) {
  console.log('Firebase auth callback. user:', user);
  if(!app) {
    console.log('Auth state updated, app NOT yet initialized')
    app = new Vue({
      vuetify,
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
    store.dispatch('updateUser');
    //store.commit('updateStuff');
  }
  else {
    console.log('Auth state updated, app already initialized')
    store.dispatch('updateUser');
    //store.commit('updateStuff');
  }
});




